// I/F of SBPS token request is here: https://github.com/quipper/aya-issues/issues/4330#issuecomment-317687200
type CreditCard = {
  number: string;
  expirationYear: string;
  expirationMonth: string;
  securityCode: string;
};

type GenerateTokenResponse = {
  errorCode: string;
  result: string;
  tokenResponse: {
    cardBrandCode: string;
    ccExpiration: string;
    maskedCcNumber: string;
    token: string;
    tokenKey: string;
  };
};

export class SbpsCreditCardTokenGenerator {
  private static SUCCESS_RESPONSE = 'OK';

  tokenLib: any;
  merchantId: string;
  serviceId: string;

  constructor({
    tokenLib,
    merchantId,
    serviceId,
  }: {
    tokenLib: any;
    merchantId: string;
    serviceId: string;
  }) {
    this.tokenLib = tokenLib;
    this.merchantId = merchantId;
    this.serviceId = serviceId;
  }

  generate(creditCard: CreditCard) {
    const deferred = $.Deferred();
    const request = new SbpsCreditCardTokenRequest({
      creditCard,
      merchantId: this.merchantId,
      serviceId: this.serviceId,
    });
    this.tokenLib.generateToken(
      request.buildParams(),
      this._generated(deferred),
    );
    return deferred.promise();
  }

  private _generated(deferred: JQuery.Deferred<any>) {
    return (response: GenerateTokenResponse) => {
      if (response.result === SbpsCreditCardTokenGenerator.SUCCESS_RESPONSE) {
        deferred.resolve(
          response.tokenResponse.token,
          response.tokenResponse.tokenKey,
        );
      } else {
        const error = SbpsCreditCardTokenError.create(response.errorCode);
        deferred.reject(error);
      }
    };
  }
}

class SbpsCreditCardTokenRequest {
  creditCard: CreditCard;
  merchantId: string;
  serviceId: string;

  constructor({
    creditCard,
    merchantId,
    serviceId,
  }: {
    creditCard: CreditCard;
    merchantId: string;
    serviceId: string;
  }) {
    this.creditCard = creditCard;
    this.merchantId = merchantId;
    this.serviceId = serviceId;
  }

  buildParams() {
    return {
      merchantId: this.merchantId,
      serviceId: this.serviceId,
      ccNumber: this.creditCard.number,
      ccExpiration: this.expiration(),
      securityCode: this.creditCard.securityCode,
    };
  }

  private expiration() {
    return `${this.creditCard.expirationYear}${this.creditCard.expirationMonth}`;
  }
}

// SBPS does not check if security_code is blank
export class SbpsCreditCardTokenError {
  private static ERROR_CODE_ITEM_MAP: { [key: string]: string } = {
    '001': 'merchant_id',
    '002': 'service_id',
    '003': 'card_number',
    '004': 'card_expiration',
    '005': 'card_security_code',
    '999': 'something',
  };

  private static ERROR_CODE_TYPE_MAP: { [key: string]: string } = {
    '03': 'blank',
    '04': 'invalid_char',
    '05': 'digits',
    '07': 'undefined',
    '99': 'internal_server',
  };

  constructor(
    public item: string,
    public type: string,
  ) {}

  public static create(errorCode: string): SbpsCreditCardTokenError {
    const item =
      SbpsCreditCardTokenError.ERROR_CODE_ITEM_MAP[errorCode.slice(2, 5)];
    const type =
      SbpsCreditCardTokenError.ERROR_CODE_TYPE_MAP[errorCode.slice(0, 2)];
    return new SbpsCreditCardTokenError(item, type);
  }
}
